import { cwslapi } from "../index";

// 礼遇商品列表获取 - 礼遇管理
export const getGiftListApi = (data) => { 
  return cwslapi({
    url: "/Gift/getGiftList",
    method: "post",
    data,
  });
};


// 领取礼遇福利 - 礼遇管理
export const getGiftPrizeApi = (data) => { 
  return cwslapi({
    url: "/Gift/getGiftPrize",
    method: "post",
    data,
  });
};

